import { ChangeEventHandler, useState } from "react";
import TextInput from "../TextInput";
import SecondaryButton from "../SecondaryButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

type Props = {
    password: string;
    onChange: ChangeEventHandler<HTMLInputElement>;
};

const PasswordInput = ({ password, onChange }: Props) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    return (
        <>
            <TextInput
                id="password"
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                className="mt-1 block w-full"
                autoComplete="current-password"
                onChange={onChange}
                data-dusk="password-input"
            />
            <SecondaryButton onClick={() => setShowPassword(!showPassword)}>
                {`${showPassword ? "Hide" : "Reveal"} `}
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </SecondaryButton>
        </>
    );
};

export default PasswordInput;
